import React, { useEffect, useState } from 'react'

import { looksLikeChatAudioAttachment } from 'utils/chatAttachmentLimits'

import ChatAudioPlayer from './ChatAudioPlayer'

import * as S from './styles'

interface Props {
  fileUrl?: string
  fileName?: string
  contentType?: string
  messageSid?: string
  getFreshMediaDownloadUrl?: (messageSid: string) => Promise<string | null>
  className?: string
}

const ChatMessageAudioPlayer: React.FC<Props> = ({
  fileUrl,
  fileName,
  contentType,
  messageSid,
  getFreshMediaDownloadUrl,
}) => {
  const [src, setSrc] = useState<string | undefined>(fileUrl)

  const isAudio = looksLikeChatAudioAttachment(fileUrl, fileName, contentType)

  useEffect(() => {
    setSrc(fileUrl)
    if (!isAudio) return
    let cancelled = false
    const resolve = async () => {
      if (getFreshMediaDownloadUrl && messageSid) {
        try {
          const u = await getFreshMediaDownloadUrl(messageSid)
          if (!cancelled && u) {
            setSrc(u)
            return
          }
        } catch {
          /* ignore */
        }
      }
      if (!cancelled) {
        setSrc(fileUrl)
      }
    }
    void resolve()
    return () => {
      cancelled = true
    }
  }, [fileUrl, messageSid, isAudio, getFreshMediaDownloadUrl])

  if (!isAudio) {
    return null
  }

  if (!src) {
    return <S.FileSizeLabel>Carregando áudio…</S.FileSizeLabel>
  }

  return <ChatAudioPlayer src={src} variant="message" />
}

export default ChatMessageAudioPlayer
